export function matchesPermissionGrant(grantedPermission: string, requiredPermission: string): boolean {
  const granted = grantedPermission.trim().toUpperCase();
  const required = requiredPermission.trim().toUpperCase();

  if (granted === required) {
    return true;
  }

  if (!granted.endsWith('.*')) {
    return false;
  }

  const prefix = granted.slice(0, -1);
  return required.startsWith(prefix);
}

export function hasPermission(
  grantedPermissions: readonly string[],
  requiredPermission: string,
): boolean {
  return grantedPermissions.some((grantedPermission) => matchesPermissionGrant(grantedPermission, requiredPermission));
}

export function hasAnyPermission(
  grantedPermissions: readonly string[],
  requiredPermissions: readonly string[],
): boolean {
  return requiredPermissions.some((requiredPermission) => hasPermission(grantedPermissions, requiredPermission));
}

export function hasAllPermissions(
  grantedPermissions: readonly string[],
  requiredPermissions: readonly string[],
): boolean {
  return requiredPermissions.every((requiredPermission) => hasPermission(grantedPermissions, requiredPermission));
}
